import React from 'react';

const API_BASE_URL = 'https://rudrakshenterprises.liveindiatech.com';

// Helper function to handle category image URLs correctly on live server
const getCorrectImageUrl = (url) => {
    if (!url) return 'https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&w=400&q=80';
    if (url.includes('127.0.0.1:8000') || url.includes('localhost:8000')) {
        return url.replace(/https?:\/\/(127\.0\.0\.1|localhost):8000/, 'https://rudrakshenterprises.liveindiatech.com');
    }
    if (url.startsWith('/')) {
        return `https://rudrakshenterprises.liveindiatech.com${url}`;
    }
    return url;
};

export default function Categories({ setActiveCategory, setCurrentPage }) {
    const categoriesList = [
        { id: 'puja', name: 'Puja Samagri', image: '/puja1.jpg', desc: 'Pure items for daily rituals' },
        { id: 'herbal', name: 'Herbal Products', image: '/puja2.jpg', desc: 'Natural skin & hair care' },
        { id: 'jaivik', name: 'Jaivik Products', image: '/puja3.jpg', desc: 'Chemical-free food items' },
        { id: 'ayurvedic', name: 'Ayurvedic Range', image: '/puja4.jpg', desc: 'Classical wellness formulas' },
        { id: 'organic', name: 'Organic Lifestyle', image: '/puja5.jpg', desc: 'Wholesome daily essentials' }
    ];

    const handleCategoryClick = (catId, e) => {
        if (e) e.stopPropagation();

        // Sabse pehle exact category set karein
        if (typeof setActiveCategory === 'function') {
            setActiveCategory(catId);
        }
        // Phir page ko category view par shift karein
        if (typeof setCurrentPage === 'function') {
            setCurrentPage('category');
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <section className="w-full px-4 sm:px-8 md:px-12 lg:px-20 py-12 bg-white">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
                    {categoriesList.map((cat) => {
                        const categoryImage = getCorrectImageUrl(cat.image);
                        return (
                            <div
                                key={cat.id}
                                onClick={(e) => handleCategoryClick(cat.id, e)}
                                className="bg-gray-50 hover:bg-orange-50/50 p-6 rounded-3xl border border-gray-100 hover:border-orange-200 transition-all duration-300 cursor-pointer flex flex-col items-center text-center group shadow-sm hover:shadow-md"
                            >
                                <div className="w-20 h-20 rounded-2xl bg-white shadow-md overflow-hidden mb-4 p-2 border border-gray-100 flex items-center justify-center">
                                    <img
                                        src={categoryImage}
                                        alt={cat.name}
                                        onError={(e) => { e.target.onerror = null; e.target.src = 'https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&w=400&q=80'; }}
                                        className="w-full h-full object-cover group-hover:scale-110 transition duration-500 rounded-xl"
                                    />
                                </div>
                                <h3 className="font-extrabold text-gray-900 text-sm sm:text-base group-hover:text-orange-600 transition">
                                    {cat.name}
                                </h3>
                                <p className="text-xs text-gray-500 mt-1 line-clamp-2">
                                    {cat.desc}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}